import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services';

@Injectable()
export class PackagingService {

    private packagingURL = environment.fulfillmentURL + 'packaging/';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }

    getPackagings() {
        return this.http.get(this.packagingURL, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let packagings = res.json();
                return packagings;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load packagings"));
            });
    }

    addPackaging(packaging: any) {
        return this.http.post(this.packagingURL, packaging, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not create packaging"));
            });
    }

    deletePackaging(packagingName: string) {
        return this.http.delete(this.packagingURL + packagingName, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete packaging"));
            });
    }

    getPackagingByName(packagingName: string) {
        return this.http.get(this.packagingURL + packagingName, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let packagings = res.json();
                return packagings;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load packaging"));
            });
    }

    addOrderPackaging(packagingName: string, orderReference: string) {
        return this.http.put(this.packagingURL + packagingName + '/order/' + orderReference, '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add order packaging"));
            });
    }

    deleteOrderPackaging(packagingName: string, orderReference: string) {
        return this.http.delete(this.packagingURL + packagingName + '/order/' + orderReference, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete order packaging"));
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/packaging.service.ts